// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__9Bk2Q","title":"styles_title__tzyXS"};